module.exports = {
  appStoreId: '992607465',
  playStoreId: 'uk.co.gousto.gousto',
  show_smart_banner: true,
  advertise_on_homepage: false,
  appStoreLink: 'https://itunes.apple.com/gb/app/gousto/id992607465?mt=8',
  playStoreLink: 'https://play.google.com/store/apps/details?id=uk.co.gousto.gousto&hl=en_GB',
}
